import { useContext } from 'react';
import { useBusinessCollectionMenuItemsType } from '../../../../../../Utils/ObjektVyUtils';
import { FranvaroContext } from '../../../../SystemAdministration/ObjektVyer/User/Context/FranvaroContext/FranvaroContext';

export const useBokforderBusinessCollectionMenuItems: useBusinessCollectionMenuItemsType =
  () => {
    const franvaroContext = useContext(FranvaroContext);

    return [
      {
        id: 'Hantera frånvaro',
        caption: 'Hantera frånvaro',
        onClick: () => {
          franvaroContext.setFranvaroDialogOpen(true);
        },
        iconType: 'account_card_details',
      },
    ];
  };
